import React from "react";
import useUser from "../../../../hooks/super/useUser";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function VerifyUserModal({ open, handleClose, email, userName, adminFlag }) {
  const { verifyUser, verifyAdmin } = useUser();
  const [busy, setBusy] = React.useState(false);

  const list = Array.isArray(userName) ? userName : [];
  const subjects = adminFlag ? "administrator" : "user";
  const plural = list.length > 1 ? "s" : "";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (adminFlag) await verifyAdmin(email);
      else await verifyUser(email);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="success"
      title={`Verify ${subjects}${plural}?`}
      body={`The selected ${subjects}${plural} will be marked verified.`}
      items={list.map((u) => ({ id: u.id, title: u.email }))}
      submitLabel="Verify"
      loading={busy}
    />
  );
}

export default VerifyUserModal;
